import { Component, OnInit, Input } from '@angular/core';
import { JobDetailsService } from '../../service/job-details.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-job-details',
	templateUrl: './job-details.component.html'
})
export class JobDetailsComponent implements OnInit {
	jobDetails: any;
	id: string;
	reqId: any;
	currentLang = '';
	companyId: string;
	updateDate: any;
	deadline: any;

	constructor(private jobDetailsService: JobDetailsService,
		private router: Router,
		public route: ActivatedRoute,
		private titleService: Title,
		private translateService: TranslateService) {
		this.route.params.subscribe(params => {
			if (params.id) {
				this.reqId = params.id;
				this.getJobDetails();
			}
		});
		this.companyId = localStorage.getItem('companyId');
	}

	ngOnInit() {
		this.getPageUpdateDate();
		this.titleService.setTitle('Ameriabank');
	}

	getJobDetails() {
		this.currentLang = localStorage.getItem('lang');

		this.jobDetailsService.getJobDetails(this.reqId, this.currentLang).subscribe((result) => {
			if (result && Object.keys(result).length) {
				this.jobDetails = result;
				
				this.translateService.get('bankName').subscribe(name => {
					this.titleService.setTitle(`${this.jobDetails.JobTitle} ${name}`);
				});

				if (this.jobDetails.ApplicationDeadline) {
					const originalDeadlineSplit = this.jobDetails.ApplicationDeadline.split('T');
					const originalDay = originalDeadlineSplit[0].split('-');
					const dayToView = originalDay[2] + '/' + originalDay[1] + '/' + originalDay[0];
					this.deadline = dayToView;
				}
				if (this.jobDetails.Id === 0) {
					this.router.navigate(['/404']);
				}
				localStorage.setItem('id', this.reqId);
			}
		});
	}

	getPageUpdateDate() {
		this.jobDetailsService.getPageUpdateDate(this.companyId).subscribe((result) => {
			if (result) {
				const originalDate = result;
				// @ts-ignore
				const originalDateSplit = originalDate.split('T');
				const originalDay = originalDateSplit[0].split('-');
				const originalHours = originalDateSplit[1].split(':');
				const dayToView = originalDay[2] + '/' + originalDay[1] + '/' + originalDay[0];
				const hoursToview = originalHours[0] + ':' + originalHours[1];
				this.updateDate = dayToView + ',' + ' ' + hoursToview;
			}
		});
	}

}
